import { combineReducers } from '@reduxjs/toolkit';
import mapoptionsSlice from "./mapoptions";
import halfwaySlice from "./halfway";
import poiSlice from "./poi";
import mapKitSlice from "./mapkit";
import googleMapsSlice from "./googlemaps";

export const rootReducer = combineReducers({
    mapoptions: mapoptionsSlice,
    halfway: halfwaySlice,
    poi: poiSlice,
    mapkit: mapKitSlice,
    googlemaps: googleMapsSlice
});

export type RootState = ReturnType<typeof rootReducer>;